import { jsx as _jsx } from "react/jsx-runtime";
import { Filter, SearchInput } from "react-admin";
const ListFilter = ({ inputProps, placeholder, source }) => {
    return (_jsx(Filter, { ...inputProps, children: _jsx(SearchInput, { placeholder: placeholder, source: source, alwaysOn: true }) }));
};
export default ListFilter;
